var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reply-message"},[_vm._v("这是回复的消息[预留]")])}
var staticRenderFns = []

export { render, staticRenderFns }